var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"p-5 text-center"},[_c('font-awesome-icon',{attrs:{"icon":"circle-notch","spin":""}}),_vm._v(" Please wait... ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }